import { render, staticRenderFns } from "./footer-informations.vue?vue&type=template&id=62e3ec36&"
import script from "./footer-informations.vue?vue&type=script&lang=js&"
export * from "./footer-informations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports